import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SenderInfo} from '../../../models/SenderInfo';
import {CommonService} from '../../../services/common.service';
import {FileService} from '../../../services/file.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';
import {io} from 'socket.io-client';

@Component({
    selector: 'app-college-management',
    templateUrl: './college-management.component.html',
    styleUrls: ['./college-management.component.scss']
})
export class CollegeManagementComponent implements OnInit {
    pageTitle: string;
    selectedFile: any;
    socket = null;
    senders: MatTableDataSource<SenderInfo> = new MatTableDataSource<SenderInfo>();
    sender: SenderInfo = {
        address: '',
        name: '',
        description: ''
    };
    imageSource: any;
    collegeInfo: any;
    collegeName: string;
    collegeEmail: string;
    collegeWebSite: string;
    collegeFax: string;
    collegeAddress: string;
    collegePhone: string;
    departmentEmails: MatTableDataSource<any> = new MatTableDataSource<any>();
    syncHistory: MatTableDataSource<any> = new MatTableDataSource<any>();
    displaySyncHistoryColumns = ['startedAt', 'endedAt', 'duration', 'sync_display_name', 'sync_email', 'sync_telephone'];
    displayEmailColumns = ['firstName', 'lastName', 'email', 'department'];
    departmentEmail = {
        firstName: '',
        lastName: '',
        email: '',
        department: ''
    };
    isLoading: boolean;
    syncHistoryLoading: boolean;
    socketPending: boolean;
    backupPending: boolean;
    syncPending: boolean;
    syncObject = {
       message: 'Test sync',
        status: '',
        stage: '',
        progress: '0',
        error: 0
    };
    displayedColumns = ['id', 'address', 'name', 'description', 'action'];
    @ViewChild('imageElement', {static: false}) imageElement: ElementRef;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild('syncPaginator', {static: true}) syncPaginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild('fileInput', {static: false}) fileInput: ElementRef;
    imageUploading: boolean;
    showStudentsMessage: boolean;
    newClass = '';
    syncStarted: boolean;
    syncStudents: number;
    syncParents: number;
    syncEmployees: number;

    constructor(public dialog: MatDialog,
                private commonService: CommonService,
                public toastMessagesService: ToastMessagesService,
                public fileService: FileService) {
        this.pageTitle = 'Διαχείριση Κολλεγίου';
        this.imageSource = '';
        this.collegeName = '';
        this.collegeEmail = '';
        this.collegeWebSite = '';
        this.collegePhone = '';
        this.collegeAddress = '';
        this.collegeFax = '';
        this.imageUploading = false;
        this.isLoading = false;
        this.syncHistoryLoading = false;
        this.showStudentsMessage = false;
        const currentYear = new Date().getFullYear();
        const previousYear = +currentYear - 1;
        this.newClass = `Απόφοιτοι ${previousYear}-${currentYear}`;
        this.syncStarted = false;

        this.socketPending = false;
        this.backupPending = false;
        this.syncPending = false;
    }

    async ngOnInit() {
        try {
            await this.initCollegeInfo();
            await this.getLogo();
            await this.getSendersInfo();
            await this.initDepartmentEmails();
            await this.initSyncHistory();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
        }
    }

    async initDepartmentEmails() {
        try {
            const result = await this.commonService.getList(`college/emails`);
            this.departmentEmails = new MatTableDataSource<any>(result.object);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async getLogo() {
        try {
            const res = await this.fileService.downloadFile(`college/logo`);
            const reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = () => {
                this.imageSource = reader.result;
            };
        } catch (e) {
            // this.toastMessagesService.toastErrorMessage(e.message);
            this.imageSource = '';
        }
    }

    async initSyncHistory() {
        try {
            this.syncHistoryLoading = true;
            this.syncHistory = new MatTableDataSource<any>();
            const request: any = await this.commonService.getList('college/sync-history');
            for (const record of request.object) {
                record.sync_display_name = `${record.sync_first_name} ${record.sync_last_name}`;
            }

            this.syncHistory = new MatTableDataSource<any>(request.object);
            this.commonService.setPaginatorTexts(this.syncPaginator);
            this.syncHistory.paginator = this.syncPaginator;
        } catch (e) {
            throw e;
        } finally {
            this.syncHistoryLoading = false;
        }
    }

    async initCollegeInfo() {
        try {
            const result = await this.commonService.getList(`college/info`);
            this.collegeInfo = result.object[0];
            this.collegeName = this.collegeInfo.college_name;
            this.collegeEmail = this.collegeInfo.college_info_email;
            this.collegeWebSite = this.collegeInfo.college_web_site;
            this.collegePhone = this.collegeInfo.college_phone;
            this.collegeAddress = this.collegeInfo.college_address;
            this.collegeFax = this.collegeInfo.college_fax;
            this.showStudentsMessage = this.collegeInfo.showStudentsMessage && this.collegeInfo.showStudentsMessage === 1 ? true : false;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    onFileInput($event: Event) {
        const file: File = this.fileInput.nativeElement.files[0];
        this.selectedFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
            // this.imageElement.nativeElement.src = reader.result;


            const image = new Image();

            if (typeof e.target.result === 'string') {
                image.src = e.target.result;
            }

            image.onload = (i) => {
                const height = image.height;
                const width = image.width;
                console.log(file.type);
                if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                    this.toastMessagesService.toastErrorMessage(`Μη αποδεκτή μορφή εικόνας`);
                    return false;
                }
                if (height > 1000 || width > 1000) {
                    this.toastMessagesService.toastErrorMessage(`Η φωτογραφία θα πρέπει να έχει μέγιστες διαστάσεις 300px ύψος και 300px πλάτος`);
                    return false;
                } else {
                    this.imageSource = reader.result;
                    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
                        data: {
                            icon: 'add',
                            title: 'Μεταφόρτωση εικόνας',
                            message: 'Θέλετε να ανεβάσετε το λογότυπο αυτό?'
                        }
                    });

                    confirmDialog.afterClosed().subscribe(async (result: any) => {
                        if (result) {
                            try {
                                this.imageUploading = true;
                                await this.fileService.uploadFile(`college/logo`, this.selectedFile);
                                this.imageUploading = false;
                                this.toastMessagesService.toastMessages('Η μεταφόρτωση οληκλώθηκε με επιτυχία');
                                setTimeout(() => {
                                    window.location.reload();
                                }, 2000);
                            } catch (e) {
                                this.toastMessagesService.toastErrorMessage(e.message);
                            }
                        } else {
                            this.imageElement.nativeElement.src = '';
                        }
                    });
                }
            };
        };
        reader.readAsDataURL(file);
    }

    removeLogo() {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                icon: 'remove',
                title: 'Διαγραφή εικόνας',
                message: 'Θέλετε να διαγράψετε το λογότυπο αυτό?'
            }
        });

        confirmDialog.afterClosed().subscribe(async (result: any) => {
            if (result) {
                try {
                    this.imageUploading = true;
                    await this.commonService.deleteItem(`college/logo`);
                    this.imageUploading = false;
                    this.toastMessagesService.toastMessages('Η διαγραφή οληκλώθηκε με επιτυχία');
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000);
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.message);
                }
                this.imageSource = '';
            }
        });
    }

    showRemoveMessage() {
        this.toastMessagesService.toastMessages('Θα πρέπει να αφαιρέσετε πρώτα την αποθηκευμένη εικόνα');
    }

    async updateInfo() {
        const model = {
            college_name: this.collegeName,
            college_address: this.collegeAddress,
            college_phone: this.collegePhone,
            college_fax: this.collegeFax,
            college_info_email: this.collegeEmail,
            college_web_site: this.collegeWebSite
        };

        try {
            await this.commonService.updateItem(`college/info`, model);
            this.toastMessagesService.toastMessages(`Η ενημέρωση των στοιχείων ολοκληρώθηκε με επιτυχία`, `Ολοκληρώθηκε`);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    newMailInvalid() {
        return !(this.departmentEmail.firstName && this.departmentEmail.lastName
            && this.departmentEmail.email && this.departmentEmail.department);
    }

    async addNewDepartmentEmail() {
        try {
            await this.commonService.insertItem('college/emails', this.departmentEmail);
            this.clearDepartmentEmail();
            await this.initDepartmentEmails();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    clearDepartmentEmail() {
        this.departmentEmail = {
            firstName: '',
            lastName: '',
            email: '',
            department: ''
        };
    }

    async addSender() {
        try {
            const result: any = await this.commonService.insertItem(`college/email-senders`, this.sender);
            this.sender.id = result.object;
            this.senders.data.push(this.sender);
            this.senders.data = this.senders.data.slice();
            this.clearSender();
            this.toastMessagesService.toastMessages('Η προσθήκη του αποστολέα ολοκληρώθηκε με επιτυχία');

        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
        }
    }

    async getSendersInfo() {
        try {
            const sendersRequest = await this.commonService.getList('college/email-senders');
            this.senders = new MatTableDataSource<SenderInfo>(sendersRequest.object);
            this.commonService.setPaginatorTexts(this.paginator);
            this.senders.paginator = this.paginator;
            this.senders.sort = this.sort;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
        }
    }

    clearSender() {
        this.sender = {
            id: null,
            name: '',
            address: '',
            description: ''
        };
    }

    updateSender(sender: SenderInfo) {
        this.sender = sender;
    }

    updateSenderInfo() {
        const senders = this.senders.data;
        const index = senders.findIndex(s => s.id === this.sender.id);
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Ενημέρωση αποστολέα',
                message: `Είστε σίγουροι ότι θέλετε να ενημερώσετε τον αποστολέα ${this.sender.name} με email ${this.sender.address}`
            }
        });

        confirmDialog.afterClosed().subscribe(async (result) => {
            if (result) {
                try {
                    await this.commonService.updateItem('college/email-senders', this.sender);
                    senders[index] = this.sender;
                    this.senders.data = senders;
                    this.senders.data = this.senders.data.slice();
                    this.clearSender();
                    this.toastMessagesService.toastMessages('Η ενημέρωση του αποστολέα ολοκληρώθηκε με επιτυχία');
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e);
                }
            }
        });
    }

    async deleteSender(sender: SenderInfo) {
        const senders = this.senders.data;
        const index = senders.findIndex(s => s.id === sender.id);

        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Διαγραφή αποστολέα',
                message: `Είστε σίγουροι ότι θέλετε να διαγράψετε τον αποστολέα ${sender.name} με email ${sender.address}`
            }
        });

        confirmDialog.afterClosed().subscribe(async (result) => {
            if (result) {
                if (index !== -1) {
                    try {
                        await this.commonService.deleteItem(`college/email-senders?senderId=${sender.id}`);
                        senders.splice(index, 1);
                        this.senders.data = senders;
                        this.toastMessagesService.toastMessages('Η διαγραφή του αποστολέα ολοκληρώθηκε με επιτυχία');
                    } catch (e) {
                        this.toastMessagesService.toastErrorMessage(e);
                    }
                }
            }
        });
    }

    searchSenders(value: any) {
        const searchValue = value.trim().toLowerCase();
        this.senders.filter = searchValue;
    }

    simpleSync() {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Συγχρονισμός βάσης δεδομένων',
                message: 'Ειστε σίγουροι ότι θέλετε να πραγματοποιήσετε συγχρονισμό της βάσης δεδομένων?',
                icon: 'update',
                color: 'red'
            }
        });

        confirmDialog.afterClosed().subscribe(async (result) => {
            if (result) {
                try {
                    this.isLoading = true;
                    await this.commonService.getList('college/sync');
                    this.syncStarted = true;


                    setInterval(async () => {
                        if (this.syncStarted) {
                            try {
                                const response = await this.commonService.getList(`college/syncProgress`);
                                if (response) {
                                    const syncObject = response.object;

                                    if (syncObject.status === 'completed') {
                                        // this.syncStarted = false;
                                        this.toastMessagesService.toastMessages('Ο συγχρονισμός ολοκληρώθηκε με επιτυχία');
                                        await this.initSyncHistory();
                                        this.isLoading = false;
                                        return;
                                    } else {
                                        this.syncObject.message = syncObject.message;
                                        this.syncObject.status = syncObject.status;
                                        this.syncObject.stage = syncObject.stage;
                                        this.syncObject.progress = syncObject.progress;
                                        this.syncObject.error = +syncObject.hasError;
                                    }
                                }

                                // if (response && response.object.stage === 'students') {
                                //     this.syncObject.students.status = 'pending';
                                //     this.syncObject.students.data = +response.object.message;
                                // }
                                //
                                // if (response && response.object.stage === 'parents') {
                                //     this.syncObject.students.status = 'completed';
                                //     this.syncObject.parents.status = 'pending';
                                //     this.syncObject.parents.data = +response.object.message;
                                //
                                // }
                                //
                                // if (response && response.object.stage === 'employees') {
                                //     this.syncObject.students.status = 'completed';
                                //     this.syncObject.parents.status = 'completed';
                                //     this.syncObject.employees.status = 'pending';
                                //     this.syncObject.employees.data = +response.object.message;
                                //
                                // }
                                //
                                // if (response && response.object.status === 'completed') {
                                //     this.syncStarted = false;
                                //     this.toastMessagesService.toastMessages('Ο συγχρονισμός ολοκληρώθηκε με επιτυχία');
                                //     await this.initSyncHistory();
                                //     this.isLoading = false;
                                // }
                            } catch (e) {
                                this.syncStarted = false;
                                this.toastMessagesService.toastMessages('Ο συγχρονισμός ολοκληρώθηκε με επιτυχία');
                                await this.initSyncHistory();
                                this.isLoading = false;
                            }
                        }
                    }, 2000);
                    // this.initSocketCommunication();
                } catch (e) {
                    this.toastMessagesService.toastErrorMessage(e.error.error);
                    // this.isLoading = false;
                }
            }
        });
    }

    initSocketCommunication() {
        this.socket = io('http://localhost:4102', {
            reconnectionDelay: 1000,
            reconnection: true,
            transports: ['websocket'],
            agent: false,
            upgrade: false,
            rejectUnauthorized: false
        });

        this.socket.on('connect', () => {
            console.log(this.socket.id); // x8WIv7-mJelg7on_ALbx
        });

        this.socket.on('disconnect', () => {
            console.log('disconnecting from socket');
            console.log(this.socket.id); // undefined
        });

        this.socket.on('state', (response) => {
            switch (response.state) {
                case 'students':
                    this.syncStudents = (response.data * 100);
                    break;

                case 'parents':
                    this.syncParents = (response.data * 100);
                    break;

                case 'employees':
                    this.syncEmployees = (response.data * 100);
                    break;
            }
        });
    }

    graduateAndSync() {
        const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: 'Προαγωγή τελειοφοίτων και συγχρονισμός βάσης δεδομένων',
                message: 'Ειστε σίγουροι ότι θέλετε να πραγματοποιήσετε την πρωαγωγή των τελειφοίτων?',
                icon: 'upload',
                color: 'red'
            }
        });

        confirmDialog.afterClosed().subscribe(async (result) => {
            if (result) {
                try {
                    this.isLoading = true;
                    await this.commonService.getList('college/graduate-sync');
                    this.toastMessagesService.toastMessages('Ο συγχρονισμός ολοκληρώθηκε με επιτυχία');
                    await this.initSyncHistory();
                } catch (e) {
                    console.log(e);
                    this.toastMessagesService.toastErrorMessage(e.error.error);
                } finally {
                    this.isLoading = false;
                }
            }
        });
    }

    async showMessageChange() {
        try {
            // this.showStudentsMessage = !this.showStudentsMessage;
            const value = this.showStudentsMessage ? 1 : 0;
            await this.commonService.updateItem(`college/message-visibility`, {showStudentsMessage: value});
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.error.error);
        }
    }

    async databaseBackUp() {
        try {
            this.initSocketDatabaseCommunication();
            setTimeout(async () => {
                await this.commonService.getList('college/databaseBackUp');
            }, 1000);
        } catch (e) {
            this.isLoading = false;
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    displayProgressMessage() {
        let message = '';
        if(this.syncObject.stage === 'helpers') {
            return this.syncObject.message;
        } else {
            message = `${this.syncObject.message} ${this.syncObject.progress}%`;
            return message;
        }
    }

    initSocketDatabaseCommunication() {
        this.socket = io('https://eapplyserver.athenscollege.edu.gr:4001', {
            reconnectionDelay: 1000,
            reconnection: true,
            transports: ['websocket'],
            agent: false,
            upgrade: false,
            rejectUnauthorized: false
        });

        this.socket.on('connect', () => {
            console.log(this.socket.id); // x8WIv7-mJelg7on_ALbx
        });

        this.socket.on('disconnect', () => {
            console.log('disconnecting from socket');
            console.log(this.socket.id); // undefined
        });

        this.socket.on('backUp', (response) => {
            console.log(response);
            if (response.status === 'pending') {
                this.socketPending = true;
                this.backupPending = true;
            } else if (response.status === 'complete') {
                this.socketPending = false;
                this.backupPending = false;
                this.toastMessagesService.toastMessages(`Το αντίγραφο ασφαλείας της βάσης δεδομένων δημιουργήθηκε με επιτυχία`);
            } else {
                this.socketPending = false;
                this.backupPending = false;
                this.toastMessagesService.toastErrorMessage(response.message);
            }
        });
    }
}
